/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, max: NonNullable<unknown> }} Members_Limit_Reached_DescriptionInputs */



/**
* | output |
* | --- |
* | "Your {plan} plan allows up to {max} members. Upgrade your plan to add more." |
*
* @param {Members_Limit_Reached_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_limit_reached_description = /** @type {((inputs: Members_Limit_Reached_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Limit_Reached_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr ${i?.plan}-Plan erlaubt bis zu ${i?.max} Mitglieder. Upgraden Sie Ihren Plan, um weitere hinzuzufügen.`)
	return /** @type {LocalizedString} */ (`Your ${i?.plan} plan allows up to ${i?.max} members. Upgrade your plan to add more.`)
});